import { Observable } from 'rxjs';
import { filter, finalize, tap } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { API_OPTIONS, ApiOptions } from '@ng-gems/api';

import { SpinnerService } from '@app/core/services/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class SpinnerLauncherService implements HttpInterceptor {
  private spinnerService = inject(SpinnerService);
  private router = inject(Router);
  // Indicates a batch of calls sent towards backend
  private sessionId: string;
  // Indicates the num of the call among the current sessionId
  private counter: number;

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => this.spinnerService.resetSessionId()),
      )
      .subscribe();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // We only want spinner to show for call towards backends
    // we discard the notification endpoint, which occurs in background
    const options: ApiOptions = req.context.get(API_OPTIONS);
    if (!options.backendId || !options.showSpinner) {
      return next.handle(req);
    }
    this.spinnerService.start();
    if (this.sessionId !== this.spinnerService.sessionId()) {
      this.sessionId = this.spinnerService.sessionId();
      this.counter = 0;
    }
    this.counter++;
    // TODO #API for now, we send twice the same header,
    // because problem with X-Request-Id (which should be the header used)
    // are encountered on Splunk dashboard
    return next
      .handle(
        req.clone({
          setHeaders: {
            'X-Request-Id': this.spinnerService.getRequestId(this.sessionId, this.counter),
            'X-Correlation-Id': this.spinnerService.getRequestId(this.sessionId, this.counter),
          },
        }),
      )
      .pipe(finalize(() => this.spinnerService.stop()));
  }
}
